import { motion } from "framer-motion";

const reveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.8, ease: [0.6, 0.05, 0.05, 0.99] },
};

const values = [
  { n: "01", title: "Aesthetic Excellence", desc: "Every frame designed with intention." },
  { n: "02", title: "Cinematic Storytelling", desc: "Meaning, emotion, and movement in fashion." },
  { n: "03", title: "Innovation", desc: "AI, film, creative tech, and modern workflows." },
  { n: "04", title: "Speed + Consistency", desc: "Fast execution without losing quality." },
  { n: "05", title: "Influencer Collabs", desc: "Trusted creator partnerships that move brands." },
];

export default function About() {
  return (
    <section id="about" className="relative py-28 md:py-40" data-testid="about-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <motion.div {...reveal} className="flex items-center gap-3 mb-12">
          <span className="text-[11px] uppercase tracking-[0.4em] text-gold">Brand Essence</span>
          <span className="h-px flex-1 bg-[#264738] max-w-[200px]" />
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <motion.div {...reveal} className="lg:col-span-7">
            <h2 className="font-display text-ivory text-4xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight">
              We turn fashion, products and personalities into <span className="italic text-gold">cinematic experiences.</span>
            </h2>
            <p className="mt-10 text-ivory-muted text-lg md:text-xl font-light leading-relaxed max-w-2xl">
              StyleePix is a high-end fashion & cinematic content agency blending luxury aesthetics,
              film-direction craft, and next-gen media tools — creating bold, stylish, premium
              visuals for fashion designers, brands, product companies and influencers.
            </p>
          </motion.div>

          <motion.div {...reveal} className="lg:col-span-5 space-y-12">
            <div>
              <span className="text-[10px] uppercase tracking-[0.4em] text-gold">Mission</span>
              <p className="mt-3 text-ivory text-base leading-relaxed font-light">
                To turn fashion, products and personalities into cinematic experiences through
                high-taste visuals, storytelling and intelligent creative technology.
              </p>
            </div>
            <div className="hairline" />
            <div>
              <span className="text-[10px] uppercase tracking-[0.4em] text-gold">Vision</span>
              <p className="mt-3 text-ivory text-base leading-relaxed font-light">
                To deliver content to India&apos;s top fashion-first brands — distinguished by creativity,
                quality, design-driven storytelling and AI-powered speed.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Values */}
        <div className="mt-28 md:mt-40 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {values.map((v, i) => (
            <motion.div
              key={v.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="border-l border-[#264738] pl-6 py-2 hover:border-gold transition-colors duration-500 group"
            >
              <div className="font-display text-gold text-3xl mb-4 group-hover:translate-x-1 transition-transform">{v.n}</div>
              <h3 className="font-display text-ivory text-xl mb-3">{v.title}</h3>
              <p className="text-ivory-muted text-sm font-light leading-relaxed">{v.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
